import { render, staticRenderFns } from "./cookie-banner.vue?vue&type=template&id=461e438f&scoped=true&"
import script from "./cookie-banner.vue?vue&type=script&lang=js&"
export * from "./cookie-banner.vue?vue&type=script&lang=js&"
import style0 from "./cookie-banner.vue?vue&type=style&index=0&id=461e438f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461e438f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('461e438f', component.options)
    } else {
      api.reload('461e438f', component.options)
    }
    module.hot.accept("./cookie-banner.vue?vue&type=template&id=461e438f&scoped=true&", function () {
      api.rerender('461e438f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/components/cookie-banner.vue"
export default component.exports